import React, { useEffect, useState } from "react";
import api from '../../../components/api'

const Modal = (props) => {

    const energia_id = props.energia_id

    const [dadosCombustiveisResumo, setDadosCombustiveisResumo] = useState([])


    const carregaResumo = () => {


        api.get(`energiaCombustivelResumo/${energia_id}`).then((result) => {

            //console.log(result.data, 'Resumo')

            setDadosCombustiveisResumo(result.data.map((rs) => 
            
                <tr>

                    <td>
                        <center>
                        {rs.combustivel}
                        </center>
                    </td>
                    <td>
                        <div align="right">
                        {rs.consumo_total.toLocaleString('pt-BR')} {rs.unidade}
                        </div>
                    </td>
                    <td>
                        <div align="right">
                        {rs.custo_total.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}
                        </div>
                    </td>
                    <td>
                        <div align="right">
                        {rs.precoUnitario.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})} / {rs.unidade}
                        </div>
                    </td>

                </tr>
            
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })


    }


    useEffect(() => {

        carregaResumo()

    }, [energia_id])


    return (

        <div>

                <div className="modal fade" id="modalEnergiaCombustivelResumo" tabindex="-1" role="dialog" aria-hidden="true" data-focus="true" >
                    <div className="modal-dialog modal-lg" role="document" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">Combustíveis - Resumo</h1>
                            </div>
                            <div className="modal-body">


                            <div className="row">

                                <div class="col-md-12">


                                    <table width="100%" border="1" className="table table-bordered table-striped table-hover">

                                        <tr>
                                            <td  style={{ backgroundColor: '#e8d3cf'}}>
                                                <center>
                                                Combustível
                                                </center>
                                            </td>
                                            <td  style={{ backgroundColor: '#e8d3cf'}}>
                                                <center>
                                                Consumo Total
                                                </center>
                                            </td>
                                            <td  style={{ backgroundColor: '#e8d3cf'}}>
                                                <center>
                                                Custo Total
                                                </center>
                                            </td>
                                            <td  style={{ backgroundColor: '#e8d3cf'}}>
                                                <center>
                                                Preço Unitário
                                                </center>
                                            </td>

                                            
                                        </tr>

                                        {dadosCombustiveisResumo}

                                    </table>

                                   


                                </div>



                            </div>
                                    

                            </div>
                            <div className="modal-footer">

                                
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>


        </div>

    )

}

export default Modal